import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useTheme } from '@/contexts/ThemeContext';

export function ThemeDynamicColors() {
    const { theme } = useTheme();
    const location = useLocation();

    useEffect(() => {
        const root = window.document.documentElement;
        const isDark = root.classList.contains('dark') || theme === 'dark' || (theme === 'system' && window.matchMedia('(prefers-color-scheme: dark)').matches);

        // Determine the color based on route and theme
        let themeColor = isDark ? '#303030' : '#ffffff';

        // Route specific overrides
        if (location.pathname.startsWith('/settings')) {
            // Settings page uses a darker background in dark mode
            if (isDark) {
                themeColor = '#1c1c1c';
            } else {
                themeColor = '#ffffff'; // Keep white for light mode settings for now
            }
        }

        const themeMeta = document.querySelector('meta[name="theme-color"]');
        if (themeMeta) {
            themeMeta.setAttribute('content', themeColor);
        } else {
            const meta = document.createElement('meta');
            meta.setAttribute('name', 'theme-color');
            meta.setAttribute('content', themeColor);
            document.head.appendChild(meta);
        }

        // Also update iOS status bar style
        const appleStatusMeta = document.querySelector('meta[name="apple-mobile-web-app-status-bar-style"]');
        if (appleStatusMeta) {
            // 'black-translucent' allows the content to go under the status bar, 'black' is opaque black.
            // For standard PWA behavior matching theme-color, we usually rely on theme-color in newer iOS,
            // but 'black' or 'default' (white) are the standard legacy values.
            // Let's stick effectively to what was there, but ensure it syncs.
            appleStatusMeta.setAttribute('content', isDark ? 'black' : 'default');
        }

    }, [theme, location.pathname]);

    return null;
}
